var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-card container-view"},[_c('search-view',{attrs:{"meta":_vm.spMeta},on:{"search":_vm.handleSearch}}),_c('table-tree-view',{ref:_vm.tlRefName,attrs:{"meta":_vm.tlMeta,"filter-params":_vm.filterParams},scopedSlots:_vm._u([{key:"prefix-btn",fn:function(ref){
var conf = ref.conf;
var choseData = ref.choseData;
return [_vm._t("prefix-btn",null,{"conf":conf,"choseData":choseData})]}},{key:"add-btn",fn:function(ref){
var conf = ref.conf;
return [_vm._t("add-btn",null,{"conf":conf})]}},{key:"suffix-btn",fn:function(ref){
var conf = ref.conf;
var choseData = ref.choseData;
return [_vm._t("suffix-btn",null,{"conf":conf,"choseData":choseData})]}},{key:"buttons",fn:function(ref){
var scope = ref.scope;
return [_vm._t("buttons",null,{"scope":scope})]}},{key:"inner-before-extend-btn",fn:function(ref){
var scope = ref.scope;
return [_vm._t("inner-before-extend-btn",null,{"scope":scope})]}},{key:"view-btn",fn:function(ref){
var scope = ref.scope;
var conf = ref.conf;
return [_vm._t("view-btn",null,{"conf":conf,"scope":scope})]}},{key:"edit-btn",fn:function(ref){
var scope = ref.scope;
var conf = ref.conf;
return [_vm._t("edit-btn",null,{"conf":conf,"scope":scope})]}},{key:"delete-btn",fn:function(ref){
var scope = ref.scope;
var conf = ref.conf;
return [_vm._t("delete-btn",null,{"conf":conf,"scope":scope})]}},{key:"inner-after-extend-btn",fn:function(ref){
var scope = ref.scope;
return [_vm._t("inner-after-extend-btn",null,{"scope":scope})]}}],null,true)},[_c('tempalte',{scopedSlots:_vm._u([{key:"operation-bar",fn:function(ref){
var conf = ref.conf;
var choseData = ref.choseData;
return [_vm._t("operation-bar",null,{"conf":conf,"choseData":choseData})]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }